const locale = (state = 'en', action) => {
	switch (action.type) {
		case 'UPATE_STORE_LOCALE':
			return action.payload
		default: break
	}
	return state
}

export default locale